import { useCallback } from 'react'
import styled, { css } from 'styled-components'
import translate from '@i18n'

import useAuthentication from '@hooks/useAuthentication'
import useUser from '@hooks/useUser'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import useViewportTracking from '@hooks/useViewportTracking'

import FollowMyTeamSportCompetitorsList from './FollowMyTeamSportCompetitorsList'
import FmTOnboardingContainer from '@components/FmtOnboardingContainer/FmTOnboardingContainer'
import FollowMyTeamDrawerHeader from '../FollowMyTeamDrawer/Header'

const Container = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing16};
    padding: 0 ${spacing16};
  `}
`

const LoginMessage = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        catchword: {
          medium2: { bundledCSS: catchwordMedium2CSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${catchwordMedium2CSS}
  `}
`

const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`

const FollowMyTeamSelectTeam = ({ onClose }: { onClose: () => void }) => {
  const user = useUser()
  const { login } = useAuthentication()

  const onLogin = () => login({ prefix: 'FMT', loginCase: 'email_only' })

  const onImpressionEvent = useCallback<TrackingFnType>(
    () => ({
      event: 'select_team_impression',
    }),
    []
  )

  const trackedOnImpression = useTracking(onImpressionEvent)

  const viewportRef = useViewportTracking({
    track: true,
    onImpression: trackedOnImpression,
  })

  return (
    <Container ref={viewportRef}>
      <FollowMyTeamDrawerHeader
        title={translate('followMyTeam.selectTeam')}
        onClose={onClose}
      />
      <FmTOnboardingContainer position="selectTeam" />
      {!user && (
        <LoginMessage>
          {translate('followMyTeam.alreadyAdded')}{' '}
          <StyledLink onClick={onLogin}>
            {translate('followMyTeam.login')}
          </StyledLink>
        </LoginMessage>
      )}
      <FollowMyTeamSportCompetitorsList />
    </Container>
  )
}

export default FollowMyTeamSelectTeam
